import React from "react";
import Footer from "../../Component/Layout/Footer";
import Header from "../../Component/Layout/Header";
import { Row, Col, Container } from "react-bootstrap";
import PageBanner from "../../Component/Layout/PageBanner";

export default function BugBounty() {
  return (
    <>
      <Header />
      <PageBanner PageTitle="BUG BOUNTY" />
      <section className="pagesection">
        <Container className="py-5">
          <Row>
            <Col>
              <p>
                If you Find any bugs in our smart contracts, we encourage you to
                report it to <a href="mailto:info@hotfriescoin.com">info@hotfriescoin.com</a>
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
}
